import { FC } from 'react';
import { css } from '@emotion/react';
import { WeaveCopilotV1 } from '@frontend/api-weave-copilot';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { useChatbotAction } from '../../hooks/use-chatbot-action';
import { useChatbotAssistant } from '../../provider/chatbot-assistant.provider';
import { getWeaveCopilotTrackingId, WEAVE_COPILOT_ACTIONS } from '../../tracking-ids';
import { ChatbotAction } from '../../types';

interface ChatbotActionsProps {
  actions?: ChatbotAction[];
}
export const ChatbotActions: FC<ChatbotActionsProps> = ({ actions }) => {
  if (!actions || actions.length === 0) {
    return null;
  }
  return (
    <div css={defaultStyles.container}>
      {actions?.map((action, index) => (
        <ChatbotActionUI key={index} action={action} />
      ))}
    </div>
  );
};

export const ChatbotActionUI: FC<{ action: ChatbotAction }> = ({ action }) => {
  const { source } = useChatbotAssistant();
  const trackingId = getWeaveCopilotTrackingId({
    source,
    action: WEAVE_COPILOT_ACTIONS.chatAction,
  });

  const { handleAction } = useChatbotAction({ source });

  if (
    action.type === WeaveCopilotV1.Types.ActionType.ACTION_TYPE_SETTING_LINK ||
    action.type === WeaveCopilotV1.Types.ActionType.ACTION_TYPE_FEATURE_LINK
  ) {
    return (
      <Button
        variant='tertiary'
        trackingId={trackingId}
        onClick={() => handleAction(action)}
        css={defaultStyles.settingsLinkButton}
        size='large'
      >
        {action.label}
        <Icon name='arrow-right-small' />
      </Button>
    );
  }

  return null;
};

const defaultStyles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `,
  settingsLinkButton: css`
    border: 1px solid ${theme.colors.primary50};
    background-color: ${theme.colors.white};
    border-radius: ${theme.borderRadius.medium};
  `,
};
